import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setListData } from "src/store/reducers/fulfillListReduce";
import { useAppSelector } from "src/store/actions/action";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ko from "date-fns/locale/ko";
registerLocale("ko", ko);
import Chip from "../common/Chip";
import DatapickerInput from "../common/Datepicker";
import CalendarHeader from "../common/CalendarHeader";
import styled from "styled-components";
import "src/styles/react-datepicker.css";
import { check } from "prettier";

interface dataProps {
  filterList: any;
  changeChecked?(value: ListFilter, key: string): void;
  setInitFunc?: any;
}

const FulfillFilterItem = (props: dataProps) => {
  const dispatch = useDispatch();
  const fulfillListReduce = useAppSelector((state) => state.fulfillListReduce);
  const [chipsData, setChipsData] = useState(props.filterList);
  const { fulfillFilter, assessFilter, typeFilter, groupChannelFilter } = chipsData;

  useEffect(() => {
    // console.log(fulfillFilter);
  }, [chipsData]);

  // 평가여부
  const [hasAssess, setHasAssess] = useState<boolean>(false);

  useEffect(() => {
    if (fulfillListReduce.fulfillSearchArray?.includes("이행")) {
      setHasAssess(true);
    } else {
      setHasAssess(false);
    }
  }, [fulfillListReduce]);

  useEffect(() => {
    setChipsData(props.filterList);
  }, [props.filterList]);

  useEffect(() => {
    const getSelectedFulfill = fulfillFilter.data.filter((v: any) => v.checked === true).map((v: any) => v.type);
    const getSelectedAssess = assessFilter.data.filter((v: any) => v.checked === true).map((v: any) => v.type);
    const getSelectedType = typeFilter.data.filter((v: any) => v.checked === true).map((v: any) => v.type);
    const getSelectedGroupChannel = groupChannelFilter?.data?.filter((v: any) => v.checked === true).map((v: any) => v.type) || [];
    const newChipsData = getSelectedType.concat(getSelectedFulfill).concat(getSelectedAssess).concat(getSelectedGroupChannel);

    dispatch(
      setListData({
        filterList: chipsData,
        fulfillSearchArray: newChipsData,
      }),
    );
  }, [chipsData]);

  const changeChecked = (value: any) => {
    if (fulfillFilter.data.includes(value)) {
      // 토글, 중복선택X
      const getSelectedFulfill = fulfillFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: false }));
      const setResetAssess = assessFilter.data.map((v: any) => (v.type === "이행" ? { ...v, checked: !v.checked } : { ...v, checked: false }));

      if (value.type === "이행") {
        setHasAssess(true);
        setChipsData({
          ...chipsData,
          fulfillFilter: {
            ...fulfillFilter,
            data: getSelectedFulfill,
          },
          assessFilter: {
            ...assessFilter,
            data: setResetAssess,
          },
        });
      } else {
        setHasAssess(false);
        setChipsData({
          ...chipsData,
          fulfillFilter: {
            ...fulfillFilter,
            data: getSelectedFulfill,
          },
          assessFilter: {
            ...assessFilter,
            data: setResetAssess,
          },
        });
      }
    }
    if (assessFilter.data.includes(value)) {
      if (hasAssess) {
        // 토글, 중복선택X
        const getSelectedAssess = assessFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: false }));
        setChipsData({
          ...chipsData,
          assessFilter: {
            ...assessFilter,
            data: getSelectedAssess,
          },
        });
      } else {
        return;
      }
    }
    if (typeFilter.data.includes(value)) {
      // 토글, 중복선택O
      const getSelectedType = typeFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: v.checked }));
      setChipsData({
        ...chipsData,
        typeFilter: {
          ...typeFilter,
          data: getSelectedType,
        },
      });
    }
    if (groupChannelFilter?.data?.find((item: any) => item.type === value.type)) {
      // 토글, 중복선택O
      const getSelectedGroupChannel = groupChannelFilter.data.map((v: any) => (v.type === value.type ? { ...v, checked: !v.checked } : { ...v, checked: v.checked }));
      setChipsData({
        ...chipsData,
        groupChannelFilter: {
          ...groupChannelFilter,
          data: getSelectedGroupChannel,
        },
      });
    }
  };

  return (
    <>
      <FilterItemSet>
        <p className="title">선택한 조건</p>
        <div>
          {fulfillFilter.data.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
          {assessFilter.data.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
          {typeFilter.data.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
          {groupChannelFilter?.data?.map((value: ListFilter, index: number) => {
            return (
              value.checked && (
                <Chip variant="contained" key={index} deleted={true} onDelete={() => changeChecked(value)}>
                  {value.type}
                </Chip>
              )
            );
          })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{fulfillFilter.title}</p>
        <div>
          {fulfillFilter &&
            fulfillFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => changeChecked(value)}>
                  {value.type}
                </Chip>
              );
            })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{assessFilter.title}</p>
        <div>
          {assessFilter &&
            assessFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip
                  variant="outlined"
                  disabled={hasAssess ? false : true}
                  selected={hasAssess ? value.checked : false}
                  key={index}
                  onClick={(e) => changeChecked(value)}
                >
                  {value.type}
                </Chip>
              );
            })}
        </div>
      </FilterItemSet>
      <FilterItemSet>
        <p className="title">{typeFilter.title}</p>
        <div>
          {typeFilter &&
            typeFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => changeChecked(value)}>
                  {value.type}
                </Chip>
              );
            })}
        </div>
      </FilterItemSet>
      {groupChannelFilter && groupChannelFilter.data && groupChannelFilter.data.length > 0 && (
        <FilterItemSet>
          <p className="title">{groupChannelFilter.title}</p>
          <div>
            {groupChannelFilter.data.map((value: ListFilter, index: number) => {
              return (
                <Chip variant="outlined" selected={value.checked} key={index} onClick={(e) => changeChecked(value)}>
                  {value.type}
                </Chip>
              );
            })}
          </div>
        </FilterItemSet>
      )}
    </>
  );
};

const FilterItemSet = styled.li`
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "wrap")}
    > div {
      margin: 15px 10px 0 0;
    }
  }
`;

const DatePickerWrap = styled.div`
  overflow: hidden;
  width: auto;
  max-width: 345px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  border: 1px solid ${({ theme }) => theme.color.lineSecondary};
  border-radius: 14px;
  padding: 0 15px;
  > .react-datepicker-wrapper {
    width: 120px;
  }
  .divide {
    position: relative;
    display: block;
    height: 28px;
    width: 20px;
    padding: 0 10px;
    margin-right: 15px;
    flex: 1;
    &::before {
      position: absolute;
      left: 0;
      top: 50%;
      content: "";
      display: block;
      width: 20px;
      height: 1px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default FulfillFilterItem;
